const QL_ALIGN_CLASSES = ['ql-align-left', 'ql-align-center', 'ql-align-right', 'ql-align-justify'];

function isElementEmptyOrOnlyBr(node: ChildNode): boolean {
  if (node.nodeType !== Node.ELEMENT_NODE) return false;
  const el = node as HTMLElement;
  const { childNodes } = el;

  if (childNodes.length === 0) return true;

  if (childNodes.length === 1 && childNodes[0].nodeName === 'BR') {
    return true;
  }

  return false;
}

function isEmptyAlignDiv(el: HTMLElement): boolean {
  if (el.tagName !== 'DIV') return false;
  const hasAlignClass = QL_ALIGN_CLASSES.some(cls => el.classList.contains(cls));

  return hasAlignClass && isElementEmptyOrOnlyBr(el);
}

/**
 * Removes empty paragraphs and empty Quill alignment divs from editor HTML
 * (e.g. inserted when toggling justify on/off). Use in WysiwygEditor onChange.
 */
export function removeEmptyBlocksFromHtml(html: string): string {
  if (typeof html !== 'string' || !html.trim()) return html;

  if (typeof DOMParser === 'undefined') return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const body = doc.body;
  const toRemove: Array<ChildNode> = [];

  for (const child of body.childNodes) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      const el = child as HTMLElement;

      if (el.tagName === 'P' && isElementEmptyOrOnlyBr(el)) {
        toRemove.push(child);
      } else if (isEmptyAlignDiv(el)) {
        toRemove.push(child);
      }
    }
  }

  toRemove.forEach(n => n.remove());

  return body.innerHTML;
}
